(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8795],{

/***/ 81965:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopify-hydrogen-development-agency",
      function () {
        return __webpack_require__(36243);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46115);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77241);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55351);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61349);








function HydrogenPage(param) {
    let { document  } = param;
    var _document_faqSection;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)("hydrogen");
    const { seo  } = document;
    const { asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    const fullUrl = "".concat("https://commerce-ui.com").concat(asPath);
    const canonicalUrl = "".concat("https://commerce-ui.com").concat(asPath === "/" ? "" : asPath.split("?")[0]);
    const seoImage = (0,_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .seoImageLoader */ .N1)(seo === null || seo === void 0 ? void 0 : seo.ogImage, seo === null || seo === void 0 ? void 0 : seo.ogAltImage);
    const faqItems = ((_document_faqSection = document.faqSection) === null || _document_faqSection === void 0 ? void 0 : _document_faqSection.faqs) || [];
    const faqSchemaMainEntity = (0,_portfolio_utils__WEBPACK_IMPORTED_MODULE_4__/* .buildFaqSchemaMainEntity */ .rP)(faqItems);
    const faqSchemaJsonLd = faqSchemaMainEntity.length > 0 ? {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqSchemaMainEntity.map((param)=>{
            let { questionName , acceptedAnswerText  } = param;
            return {
                "@type": "Question",
                name: questionName,
                acceptedAnswer: {
                    "@type": "Answer",
                    text: acceptedAnswerText
                }
            };
        })
    } : null;
    const seoElement = seo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_5__/* .NextSeo */ .PB, {
        titleTemplate: seo === null || seo === void 0 ? void 0 : seo.titleTemplate,
        title: seo.metaTitle,
        description: seo.metaDescription,
        canonical: canonicalUrl,
        openGraph: {
            url: fullUrl,
            type: "website",
            title: seo.ogTitle,
            description: seo.ogDescription,
            images: [
                ...seoImage ? [
                    seoImage
                ] : []
            ]
        },
        twitter: {
            cardType: "summary_large_image"
        }
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_5__/* .NextSeo */ .PB, {
        canonical: fullUrl
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            seoElement,
            faqSchemaJsonLd && // In this case we need to use ordinary script, instead of next-seo FAQPageJsonLd as the next-seo one is generating duplicate FAQPage schema
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                id: "hydrogen-faq-schema",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(faqSchemaJsonLd).replace(/</g, "\\u003c")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Page, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SectionTwoCards, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionTwoCardsTitle, {
                                children: document.heroSection.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionTwoCardsImageMobile, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Media */ .pU, {
                                    ...document.heroSection.image,
                                    priority: true
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionTwoCardsImageDesktop, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Media */ .pU, {
                                    ...document.heroSection.image,
                                    layout: "intrinsic",
                                    priority: true
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SectionTwoCardsDescription, {
                                children: [
                                    document.heroSection.description,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                                            ...document.heroSection.action.link,
                                            appearance: "containedTransparent",
                                            children: document.heroSection.action.label
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(AboutSection, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AboutSectionTitle, {
                                children: document.aboutSection.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AboutSectionMedia, {
                                children: "mediaPayload" in document.aboutSection.media ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Media */ .pU, {
                                    ...document.aboutSection.media,
                                    layout: "responsive",
                                    disablePlaceholderBackground: true
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .MuxPlayer */ .Ge, {
                                    playbackId: document.aboutSection.media.playbackId,
                                    poster: document.aboutSection.media.firstFrame,
                                    isAutoPlay: true
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AboutSectionIntroduction1, {
                                children: document.aboutSection.description1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AboutSectionDescription2, {
                                children: document.aboutSection.description2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(AboutSection, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AboutSectionTitle, {
                                children: document.aboutOxygenSection.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AboutSectionMedia, {
                                children: "mediaPayload" in document.aboutOxygenSection.media ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Media */ .pU, {
                                    ...document.aboutOxygenSection.media,
                                    layout: "responsive",
                                    disablePlaceholderBackground: true
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .MuxPlayer */ .Ge, {
                                    playbackId: document.aboutOxygenSection.media.playbackId,
                                    poster: document.aboutOxygenSection.media.firstFrame,
                                    isAutoPlay: true
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AboutSectionIntroduction1, {
                                children: document.aboutOxygenSection.description1
                            }),
                            document.aboutOxygenSection.description2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AboutSectionDescription2, {
                                children: document.aboutOxygenSection.description2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(MigrationSection, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultSectionTitle, {
                                children: document.migrationSection.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MigrationSectionReasons, {
                                children: document.migrationSection.reasons.map((reason, index)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(MigrationSectionReasonTerm, {
                                                children: [
                                                    reason.term,
                                                    ":\xa0"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MigrationSectionReasonDefinition, {
                                                children: reason.definition
                                            }),
                                            reason.media !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MigrationSectionReasonMedia, {
                                                children: "mediaPayload" in reason.media ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Media */ .pU, {
                                                    ...reason.media,
                                                    layout: "responsive",
                                                    objectFit: "cover"
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .MuxPlayer */ .Ge, {
                                                    playbackId: reason.media.playbackId,
                                                    poster: reason.media.firstFrame,
                                                    isAutoPlay: true
                                                })
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(AboutUsSection, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AboutUsSectionTitle, {
                                children: document.aboutUsSection.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AboutUsSectionIntroduction1, {
                                children: document.aboutUsSection.introduction1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AboutUsSectionIntroduction2, {
                                children: document.aboutUsSection.introduction2
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AboutUsCaseStudies, {
                                children: document.aboutUsSection.caseStudies.map((caseStudy, index)=>{
                                    var _caseStudy_stats;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CaseStudyCard, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CaseStudyCardBackground, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Media */ .pU, {
                                                    ...caseStudy.backgroundImage,
                                                    layout: "fill"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CaseStudyCardContent, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CaseStudyCardLeftWrap, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CaseStudyCardTitleWrapper, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CaseStudyCardTitle, {
                                                                        children: caseStudy.title
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CaseStudyCardAction, {
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                                                                            href: caseStudy.path,
                                                                            appearance: "containedTransparent",
                                                                            children: t("viewCaseStudyActionLabel")
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CaseStudyCardMedia, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Media */ .pU, {
                                                                    ...caseStudy.previewImage
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CaseStudyCardRightWrap, {
                                                        children: (_caseStudy_stats = caseStudy.stats) === null || _caseStudy_stats === void 0 ? void 0 : _caseStudy_stats.map((stat, index)=>{
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CaseStudyStat, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CaseStudyStatValue, {
                                                                        children: [
                                                                            stat.value,
                                                                            stat.symbol
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CaseStudyStatLabel, {
                                                                        children: stat.label
                                                                    })
                                                                ]
                                                            }, index);
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(QuoteSection, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuoteSectionQuote, {
                                children: document.quoteSection.quote
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(QuoteSectionAuthorWrap, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuoteSectionAvatar, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Media */ .pU, {
                                            ...document.quoteSection.avatar
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(QuoteSectionAuthor, {
                                        children: [
                                            document.quoteSection.author,
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            document.quoteSection.position
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(HelpSection, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HelpSectionTitle, {
                                children: document.helpSection.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardsGrid, {
                                children: document.helpSection.services.map((service, index)=>{
                                    const hasAction = service.action !== null && service.actionLabel !== null;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(HelpSectionCard, {
                                        hasAction: hasAction,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Typography, {
                                                variant: "heading04",
                                                color: "white",
                                                as: "h3",
                                                css: {
                                                    marginBottom: "auto"
                                                },
                                                children: service.title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Typography, {
                                                variant: "body03",
                                                color: "white",
                                                css: {
                                                    alignSelf: "flex-end"
                                                },
                                                children: service.description
                                            }),
                                            hasAction && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                                                    appearance: "containedTransparent",
                                                    ...service.action,
                                                    children: service.actionLabel
                                                })
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ResourcesSection, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultSectionTitle, {
                                children: document.resourcesSection.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardsGrid, {
                                children: document.resourcesSection.resources.map((resource, index)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ResourcesSectionCard, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ResourcesSectionCardLogo, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Media */ .pU, {
                                                    ...resource.logo,
                                                    layout: "intrinsic",
                                                    disablePlaceholderBackground: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ResourcesSectionCardPreviewImage, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Media */ .pU, {
                                                    ...resource.previewImage,
                                                    objectFit: "contain"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ResourceSectionCardBottomWrapper, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ResourceSectionCardTitleWrapper, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ResourcesSectionCardTitle, {
                                                            children: resource.title
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ResourcesSectionCardActions, {
                                                        children: resource.actions.map((action, index)=>{
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                                                                ...action.link,
                                                                appearance: "containedTransparent",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                    style: {
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 8
                                                                    },
                                                                    children: [
                                                                        action.label,
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_icons__WEBPACK_IMPORTED_MODULE_2__/* .OpenNewTab */ .mw, {})
                                                                    ]
                                                                })
                                                            }, index);
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FaqSection, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FaqSectionTitleWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqSectionTitle, {
                                        children: document.faqSection.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqSectionAction, {
                                        children: document.faqSection.actionLabel !== null && document.faqSection.action !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                                            ...document.faqSection.action,
                                            appearance: "containedTransparent",
                                            children: document.faqSection.actionLabel
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AccordionWrapper, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Accordion */ .UQ, {
                                    children: faqItems.map((faq, index)=>{
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItem */ .Qd, {
                                            value: index.toString(),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .AccordionTrigger */ .o4, {
                                                    children: faq.question
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .AccordionContent */ .vF, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .PortableText */ .YI, {
                                                        value: faq.answer,
                                                        appearance: "faq"
                                                    })
                                                })
                                            ]
                                        }, index);
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const Page = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    backgroundColor: "$hydrogenPageBackground",
    display: "grid",
    gridAutoFlow: "row",
    gap: "$96",
    "@lg": {
        gap: "$144"
    }
});
const BaseSection = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("section", {
    paddingInline: 20,
    "@lg": {
        paddingInline: 30
    }
});
const SectionTwoCards = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("section", {
    "@lg": {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "auto auto",
        rowGap: 24
    }
});
const SectionTwoCardsTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("h1", {
    paddingBlockStart: "calc(var(--sizes-headerHeight) + 32px)",
    paddingBlockEnd: 104,
    paddingInline: 20,
    projectFont: "heading01",
    color: "$white",
    textAlign: "center",
    maxWidth: 650,
    "@lg": {
        paddingBlockStart: "calc(var(--sizes-headerHeight) + 96px)",
        paddingBlockEnd: 0,
        paddingInline: 30,
        textAlign: "left"
    }
});
const SectionTwoCardsImageMobile = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    position: "relative",
    marginBlockEnd: 48,
    "@lg": {
        display: "none"
    }
});
const SectionTwoCardsImageDesktop = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "none",
    "@lg": {
        display: "block",
        gridRow: "1 / span 2",
        gridColumn: 2
    }
});
const SectionTwoCardsDescription = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: 30,
    paddingInline: 20,
    projectFont: "heading07",
    color: "$white",
    "@lg": {
        maxWidth: 548,
        gridRow: "2 / span 1",
        alignSelf: "flex-end",
        paddingInline: 30
    }
});
const AboutSection = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)(BaseSection, {
    "@lg": {
        display: "grid",
        gridTemplateColumns: "1fr 2fr",
        gap: 30
    }
});
const AboutSectionTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("h2", {
    marginBottom: 56,
    projectFont: "heading04",
    color: "$white"
});
const AboutSectionMedia = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    position: "relative",
    marginBlockEnd: 30,
    "@lg": {
        gridColumn: 2,
        width: "85%",
        maxWidth: 1080,
        height: "auto"
    }
});
const AboutSectionIntroduction1 = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("h3", {
    marginBlockEnd: 30,
    color: "$white",
    projectFont: "heading07",
    "@lg": {
        gridColumn: 2,
        width: "85%",
        maxWidth: 1080
    }
});
const AboutSectionDescription2 = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("p", {
    projectFont: "body03",
    color: "$white",
    opacity: 0.7,
    "@lg": {
        gridColumn: 2,
        width: "85%",
        maxWidth: 1080,
        opacity: 1
    }
});
const DefaultSectionTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("h2", {
    paddingBlockEnd: 56,
    projectFont: "heading04",
    color: "$white",
    "@lg": {
        maxWidth: 430
    }
});
const MigrationSection = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("section", {
    paddingInline: 20,
    "@lg": {
        display: "grid",
        gridTemplateColumns: "1fr 2fr",
        gap: 30,
        paddingInline: 30
    }
});
const MigrationSectionReasons = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "$56",
    "@lg": {
        width: "85%",
        maxWidth: 1080,
        gap: "$72"
    }
});
const MigrationSectionReasonTerm = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("span", {
    projectFont: "body03",
    color: "$white"
});
const MigrationSectionReasonDefinition = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("span", {
    projectFont: "body03",
    color: "$white_07"
});
const MigrationSectionReasonMedia = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    position: "relative",
    marginBlockStart: 30
});
const AboutUsSection = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("section", {
    paddingInline: 20,
    "@lg": {
        display: "grid",
        gridTemplateColumns: "1fr 2fr",
        gridAutoFlow: "row"
    }
});
const AboutUsSectionTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("h2", {
    paddingBlockEnd: 72,
    projectFont: "heading01",
    color: "$white",
    textAlign: "center",
    maxWidth: 200,
    margin: "0 auto",
    "@lg": {
        maxWidth: "100%",
        margin: 0,
        textAlign: "left",
        gridColumn: "1 / span 1"
    }
});
const AboutUsSectionIntroduction1 = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("h3", {
    projectFont: "heading07",
    color: "$white",
    paddingBlockEnd: 30,
    "@lg": {
        gridRow: 2,
        gridColumn: "2 / span 2",
        width: "85%",
        maxWidth: 1080
    }
});
const AboutUsSectionIntroduction2 = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("p", {
    paddingBlockEnd: 72,
    color: "$white_07",
    projectFont: "body03",
    "@lg": {
        gridRow: 3,
        gridColumn: "2 / span 2",
        paddingBlockEnd: 144,
        width: "85%",
        maxWidth: 1080
    }
});
const AboutUsCaseStudies = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    gridRow: 4,
    gridColumn: "1 / span 3",
    display: "grid",
    gap: 24,
    "@lg": {
        gap: 40
    }
});
const Card = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    position: "relative",
    overflow: "hidden",
    borderRadius: 20
});
const CaseStudyCard = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)(Card, {});
const CaseStudyCardBackground = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    position: "absolute",
    inset: 0,
    backgroundColor: "$black",
    opacity: 0.3
});
const CaseStudyCardContent = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    padding: 24,
    "@lg": {
        flexDirection: "row",
        height: 600,
        padding: 32
    }
});
const CaseStudyCardLeftWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: 48,
    "@lg": {
        flex: "1 0",
        gap: 24
    }
});
const CaseStudyCardRightWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 24,
    "@lg": {
        gap: 96
    }
});
const CaseStudyCardTitleWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: 24,
    "@lg": {
        flex: "1 0 50%"
    }
});
const CaseStudyCardTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("h3", {
    projectFont: "heading07",
    color: "$white"
});
const CaseStudyCardAction = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {});
const CaseStudyCardMedia = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    maxWidth: 360
});
const CaseStudyStat = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: 24,
    marginBlockStart: 48,
    "@lg": {
        marginBlockStart: 0
    }
});
const CaseStudyStatValue = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    projectFont: "heading01",
    color: "$white"
});
const CaseStudyStatLabel = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    projectFont: "body03",
    color: "$white"
});
const QuoteSection = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("section", {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingInline: 20,
    textAlign: "center"
});
const QuoteSectionQuote = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)(DefaultSectionTitle, {
    "@lg": {
        maxWidth: 960
    }
});
const QuoteSectionAuthorWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: 30,
    justifyContent: "center",
    alignItems: "center",
    "@lg": {
        flexDirection: "row"
    }
});
const QuoteSectionAvatar = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    margin: "0 auto",
    width: 80,
    height: 80,
    borderRadius: 8,
    overflow: "hidden"
});
const QuoteSectionAuthor = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    projectFont: "heading08",
    color: "$white"
});
const HelpSection = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("section", {
    paddingInline: 30,
    maxWidth: "$maxWidthDesktop",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginInline: "auto"
});
const HelpSectionTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)(DefaultSectionTitle, {
    textAlign: "center"
});
const CardsGrid = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: 20,
    "@lg": {
        flexDirection: "row",
        gap: 32
    }
});
const HelpSectionCard = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)(Card, {
    display: "grid",
    gridTemplateRows: "1fr 1fr",
    gap: 24,
    height: 400,
    backgroundColor: "#212121",
    padding: "24px",
    wordBreak: "break-word",
    textWrap: "balance",
    "@lg": {
        maxWidth: 500,
        flex: "1 0"
    },
    variants: {
        hasAction: {
            true: {
                gridTemplateRows: "1fr 1fr auto"
            }
        }
    }
});
const ResourcesSection = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("section", {
    maxWidth: "$maxWidthDesktop",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginInline: "auto",
    paddingInline: 20
});
const ResourcesSectionCard = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)(Card, {
    display: "flex",
    flexDirection: "column",
    padding: 24,
    backgroundColor: "#212121",
    "@lg": {
        flex: "1 0",
        maxWidth: 500
    }
});
const ResourcesSectionCardActions = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "flex",
    flexWrap: "wrap",
    gap: 16
});
const ResourcesSectionCardLogo = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    height: 30,
    marginBlockEnd: 24
});
const ResourcesSectionCardPreviewImage = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    overflow: "hidden",
    display: "grid",
    alignItems: "center",
    marginBlockEnd: 24,
    borderRadius: 4
});
const ResourceSectionCardTitleWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    minHeight: 96
});
const ResourcesSectionCardTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("h3", {
    display: "-webkit-box",
    "-webkit-line-clamp": 4,
    "-webkit-box-orient": "vertical",
    overflow: "hidden",
    projectFont: "heading08",
    color: "$white"
});
const ResourceSectionCardBottomWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: 24,
    marginBlockStart: "auto"
});
const FaqSection = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)(BaseSection, {
    "@lg": {
        display: "grid",
        gridTemplateColumns: "1fr 2fr",
        gap: 30
    }
});
const FaqSectionTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)(DefaultSectionTitle, {
    "@lg": {
        paddingBlockEnd: 0
    }
});
const FaqSectionAction = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "none",
    "@lg": {
        display: "block"
    }
});
const FaqSectionTitleWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: 32,
    alignItems: "flex-start"
});
const AccordionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    "@lg": {
        gridColumn: 2,
        width: "85%",
        maxWidth: 1080
    }
});
const Typography = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    variants: {
        variant: Object.fromEntries(Object.keys(_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .fonts */ .Rq).map((key)=>[
                key,
                {
                    projectFont: key
                }
            ])),
        color: Object.fromEntries(Object.keys(_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .colors */ .O9).map((key)=>[
                key,
                {
                    color: "$".concat(key)
                }
            ])),
        align: {
            left: {
                textAlign: "left"
            },
            center: {
                textAlign: "center"
            },
            right: {
                textAlign: "right"
            },
            justify: {
                textAlign: "justify"
            }
        }
    }
});
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (HydrogenPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2888,179], function() { return __webpack_exec__(81965); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);